import { IEmailService } from './study_group_interfaces';

export interface IStudyGroupsCapabilityConfigurationObject {
  isMobile: boolean;
  emailService?: IEmailService;
  notificationHandle?: string;
}

export class StudyGroupsCapabilityConfiguration {
  private _config: IStudyGroupsCapabilityConfigurationObject;

  constructor() {
    this._config = {
      isMobile: false,
      notificationHandle: ''
    };
  }

  get config(): IStudyGroupsCapabilityConfigurationObject {
    return this._config;
  }

  set config(configs: IStudyGroupsCapabilityConfigurationObject) {
    this._config = { ...this._config, ...configs };
  }

  setConfig(key: string, value: any): void {
    this._config[key] = value;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/study_groups_configuration.ts